// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const counter_PHOTOS = ["%(counter)s fotka", "%(counter)s fotky", "%(counter)s fotiek"];
export const count_PEOPLE_THINK_IT_IS_USEFUL = ["%(count)s \u010dlovek pova\u017euje za u\u017eito\u010dn\u00e9", "%(count)s \u013eudia pova\u017euj\u00fa za u\u017eito\u010dn\u00e9", "%(count)s \u013eud\u00ed pova\u017euje za u\u017eito\u010dn\u00e9"];
export const REVIEW_OF_ALIKE_MODEL_stroller = "Recenzia s\u00favisiaceho modelu %(stroller)s";
export const REVIEW_VERIFIED = "Overen\u00e1 recenzia";
export const STROLLER_REVIEW_RELATED_PRODUCT_IN_BAZAAR = "Pred\u00e1va teraz v baz\u00e1ri:";
export const STROLLERS_DETAILED_REVIEW = "Podrobn\u00e1 recenzia";
export const STROLLERS_NOT_APPROVED = "\u010dak\u00e1 na kontrolu";
export const USEFUL = "U\u017eito\u010dn\u00e9";
